import { render, staticRenderFns } from "./Ministries.vue?vue&type=template&id=79f841e2&scoped=true"
import script from "./Ministries.vue?vue&type=script&lang=js"
export * from "./Ministries.vue?vue&type=script&lang=js"
import style0 from "./Ministries.vue?vue&type=style&index=0&id=79f841e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f841e2",
  null
  
)

export default component.exports